(function () {
    "use strict";

    angular.module("papp").config(stateConfig);

    stateConfig.$inject = ["$stateProvider"];

    function stateConfig($stateProvider) {
        $stateProvider.state("refundDetails", {
            parent: "app",
            url: "/refund/details/:id",
            data: {
                authorities: ["bilioslo-admin", "bilioslo-admin-lese"],
            },
            views: {
                "content@": {
                    templateUrl: "app/refund/details/refund.details.html",
                    controller: "RefundDetailsController",
                    controllerAs: "vm",
                },
            },
        });
    }
})();
